// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import CopyButton from '@liquidweb-dev/undercurrent/CopyButton';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import BrandLogo from 'components/BrandLogo';
import { useLogout } from 'modules/oidc/useLogout';
import useAccountDetails from 'modules/queries/account/useDetails';

/**
 * @param {object} props
 * @param {import('@liquidweb-dev/undercurrent/Button').ButtonProps} [props.logoutButtonProps]
 */
const VerificationRequired = ({ logoutButtonProps }) => {
	const {
		data: accountUserDetailsData,
		isLoading: isAccountUserDetailsLoading,
	} = useAccountDetails({});

	const logout = useLogout();

	const accountNumber = accountUserDetailsData?.accnt;
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<BrandLogo />
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 200 }}>
				{isAccountUserDetailsLoading ? (
					<Skeleton width={100} height={24} />
				) : (
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 100,
							paddingX: 200,
						}}
					>
						<Typography variant="label-md" sx={{ fontWeight: 500 }}>
							Account # {accountNumber}
						</Typography>
						<CopyButton
							onClick={() => navigator.clipboard.writeText(accountNumber || '')}
							iconButtonProps={{ variant: 'barebones', size: 'small' }}
							tooltipProps={{ placement: 'bottom' }}
						/>
					</Box>
				)}

				<Button
					variant="link"
					onClick={logout}
					size="large"
					{...logoutButtonProps}
				>
					Logout
				</Button>
			</Box>
		</Box>
	);
};

export default VerificationRequired;
